import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Validators, FormArray } from '@angular/forms';
import { LCFormData, Settings } from './lc-forms.interface';
import { LCElementComponent } from './lc-element.component';
import { LCFormService } from './lc-forms.service';
export class LCFormComponent {
    comp: any;
private _data: LCFormData;
private _form: FormGroup;
private _matches: any[];
/**
 * @param {?} _controlGroup
 */
constructor(private _controlGroup: LCFormService) { }
/**
 * @param {?} value
 * @return {?}
 */
set lcFormData(value: LCFormData) {
        this._data = value;
        this._data.settings = this._setSettings(value.settings);
        this.sortElements();

        const /** @type {?} */ cg = this._controlGroup.create(this._data.elements);
        this._form = cg.fbGroup;
        this._matches = cg.matches;
        this.comp = {
            data: this._data,
            form: this._form,
            settings: {
                singleErrorMessage: this._data.settings.singleErrorMessage,
                errorOnDirty: this._data.settings.errorOnDirty,
                showValidation: this._data.settings.showValidation,
                extraValidation: this._data.settings.submitButtonExtraValidation || true
            }
        };
    }

    // Outputs
     submitted: EventEmitter<any> = new EventEmitter();
     changed: EventEmitter<any> = new EventEmitter();
/**
 * @return {?}
 */
submit() { this.submitted.emit(this._form.value); }
/**
 * @param {?} event
 * @return {?}
 */
onElementValueChange(event) {
        if (this._matches) {
            // console.log('this._matches: ', this._matches);
            const /** @type {?} */ key = Object.keys(event)[0], /** @type {?} */
                // See if we should check for matches
                mat = this._matches[0].find(a => a.toMatch === key);

            // Update the cg if we found a matcher
            if (mat) { this._form.controls[mat.model].updateValueAndValidity(); }
        }

        this.changed.emit(event);
    }
/**
 * @return {?}
 */
sortElements() { this._data.elements.sort((a, b) => a.order - b.order); }
/**
 * @param {?} settings
 * @return {?}
 */
private _setSettings(settings: Settings) {
        const /** @type {?} */ defaultSettings = {
            submitButton: true,
            submitButtonText: 'Submit',
            submitButtonExtraValidation: null,
            noteText: null,
            noteLabel: null,
            showValidation: true,
            singleErrorMessage: true,
            errorOnDirty: true
        };

        // Add received settings
        if (settings) {
            for (const /** @type {?} */ p in defaultSettings) {
                if (settings.hasOwnProperty(p)) { defaultSettings[p] = settings[p]; } else {
                    defaultSettings[p] = defaultSettings[p];
                }
            }
        }

        return defaultSettings;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    template: `
      <form [formGroup]="comp.form" [ngClass]="comp.data.classes?.form">
          <lc-element *ngFor="let e of comp.data.elements" [info]="{element: e, form: comp.form, settings: comp.settings, classes: comp.data.classes}" (valueChange)="onElementValueChange($event)"></lc-element>
          <div class="row">
              <div *ngIf="comp.data.settings.submitButton" [ngClass]="comp.data.classes?.submit">
                  <button type="submit" [disabled]="!comp.form.valid && comp.settings.extraValidation" [ngClass]="comp.data.classes?.submitButton">{{comp.data.settings.submitButtonText}}</button>
              </div>
              <div *ngIf="comp.data.settings.noteText" [ngClass]="comp.data.classes.note">
                  <span *ngIf="comp.data.settings.noteLabel" [ngClass]="comp.data.classes.noteLabel">{{comp.data.settings.noteLabel}}</span>&nbsp;
                  {{comp.data.settings.noteText}}
              </div>
          </div>
      </form>
    `,
    // tslint:disable-next-line:component-selector
    selector: 'lc-form'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: LCFormService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'lcFormData': [{ type: Input },],
'submitted': [{ type: Output },],
'changed': [{ type: Output },],
};
}

function LCFormComponent_tsickle_Closure_declarations() {
/** @type {?} */
LCFormComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LCFormComponent.ctorParameters;
/** @type {?} */
LCFormComponent.propDecorators;
/** @type {?} */
LCFormComponent.prototype.comp;
/** @type {?} */
LCFormComponent.prototype._data;
/** @type {?} */
LCFormComponent.prototype._form;
/** @type {?} */
LCFormComponent.prototype._matches;
/** @type {?} */
LCFormComponent.prototype.submitted;
/** @type {?} */
LCFormComponent.prototype.changed;
/** @type {?} */
LCFormComponent.prototype._controlGroup;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
